import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import { translate } from 'react-i18next';

class HighchartsPie extends Component {
    static propTypes = {
        config: PropTypes.object.isRequired,
        className: PropTypes.string,
        t: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.renderGraph();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.config.series[0].data !== this.props.config.series[0].data) {
            this.renderGraph();
        }
    }

    getGraphInstance() {
        return this.instance;
    }

    renderGraph() {
        const { t } = this.props;

        Highcharts.setOptions({
            lang: {
                decimalPoint: ',',
                months: t('months', { returnObjects: true }),
                weekdays: t('weekdays', { returnObjects: true }),
                shortMonths: t('shortMonths', { returnObjects: true }),
                shortWeekdays: t('shortWeekdays', { returnObjects: true }),
                noData: t('common:noData'),
            },
        });

        this.instance = Highcharts.chart(this.container, this.props.config);
    }

    render() {
        return (
            <div
                className={this.props.className}
                ref={(c) => { this.container = c; }}
            />
        );
    }
}

export default translate('date', { withRef: true })(HighchartsPie);

export const defaultOptions = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: null,
        spacing: [0, 0, 0, 0],
        margin: [0, 0, 0, 0],
        type: 'pie',
    },
    title: { style: { display: 'none' } },
    subtitle: { style: { display: 'none' } },
    legend: { enabled: false },
    credits: { enabled: false },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            borderWidth: 0,
            dataLabels: {
                enabled: false,
            },
        },
        series: {
            enableMouseTracking: false,
        },
    },
};



/** WEBPACK FOOTER **
 ** /src/shared/components/graph/HighchartsPie.js
 **/